export type StreamListScope = 'mine' | 'following' | 'private'

type StreamActivity = {
    last_activity?: string | null
    last_activity_at?: string | null
}

type ScopedStream = StreamActivity & {
    id: string | number
    admin_id?: string | number
    public?: boolean
    created_at?: string | null
}

export function streamActivityTimestamp(stream: StreamActivity): string | undefined {
    return stream.last_activity ?? stream.last_activity_at ?? undefined
}

export function streamsForScope<T extends ScopedStream>(
    streams: readonly T[],
    scope: StreamListScope,
    currentUserId: string | number | undefined,
): T[] {
    // A channel with no threads yet was last active when it was created, so a
    // brand-new channel lists near the top instead of below every old one.
    const activityTime = (stream: T) => {
        const time = Date.parse(streamActivityTimestamp(stream) ?? stream.created_at ?? '')
        return Number.isNaN(time) ? -Infinity : time
    }
    // Most recently active first on every tab, like Discover.
    const sorted = [...streams].sort((a, b) => activityTime(b) - activityTime(a) || 0)

    if (scope === 'mine') {
        if (currentUserId === undefined) return []
        return sorted.filter(stream => String(stream.admin_id) === String(currentUserId))
    }
    if (scope === 'private') return sorted.filter(stream => !stream.public)
    return sorted
}
